import React from "react";
import { View, Text, Button, Icon, IconsHash } from "ui";
import { styled } from "styles";
import TextInput from "./ui/TextInput";
import { userMutations } from "api";
import { notify } from "shared/services";
import ConfirmDialog from "./ConfirmDialog";

interface P {
  leftIcon?: keyof typeof IconsHash;
  title: string;
  rightIcon?: keyof typeof IconsHash;
  rightText?: string;
  onClick?: () => void;
  className?: string;
}
class ConfigureButton extends React.Component<P> {
  public state = {
    code: "",
    openDialog: false
  };

  public render = () => {
    const {
      leftIcon,
      rightIcon,
      title,
      rightText,
      onClick,
      className
    } = this.props;

    return (
      <Config
        flexDirection="column"
        bg="grey"
        mb={1}
        mt={1}
        borderRadius={10}
        flexWrap="nowrap"
        onClick={onClick}
        className={className}
      >
        <View
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
          p={2}
        >
          <View flexDirection="row" alignItems="center" flex={2}>
            {!!leftIcon && (
              <Icon color="black" name={leftIcon as any} size={1.5} />
            )}
            <Text ml={2} color="white" fontSize={3}>
              {title}
            </Text>
          </View>
          <View flexDirection="row" alignItems="center" flex={1}>
            {!!rightIcon && (
              <View>
                <Icon color="black" name={rightIcon as any} size={1.5} />
              </View>
            )}

            {!!rightText && (
              <Text
                color="white"
                fontSize={3}
                mr={2}
                flex={1}
                textAlign="right"
              >
                {rightText}
              </Text>
            )}
          </View>
        </View>
      </Config>
    );
  }
}

const Config = styled(View)`
  cursor: pointer;
`;

export default ConfigureButton;



// WEBPACK FOOTER //
// ./src/components/ConfigureButton.tsx